import { useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import wvLogo from '../../../assets/wv-logo.png';

const WestVirginiaPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'RSS - West Virginia Orders';
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = wvLogo;
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100dvh',
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        backgroundImage: {
          md: 'linear-gradient(90deg, var(--wv-secondary) 0%, var(--wv-primary) 100%)',
          xs: 'linear-gradient(180deg, var(--wv-secondary) 0%, var(--wv-primary) 100%)',
        },
      }}
    >
      <Box
        component={Link}
        to='/wv'
        sx={{
          display: 'inline-flex',
          width: {
            xs: 140,
            sm: 180,
            md: 200,
          },
          height: 'auto',
        }}
      >
        <Box
          component='img'
          src={wvLogo}
          alt={t('alt.west_virginia_lottery_logo')}
          sx={{
            display: 'block',
            width: '100%',
            height: 'auto',
          }}
        />
      </Box>

      <Outlet />
    </Box>
  );
};

export default WestVirginiaPage;
